import { Component, Input } from '@angular/core';
import { UserRecurringPayment } from '@app/modules/recurring-payments/classes/user-recurring-payment';

@Component({
    selector: 'app-recurring-payment-info',
    templateUrl: './recurring-payment-info.component.html',
})
export class RecurringPaymentInfoComponent {
    @Input() userRecurringPayments: UserRecurringPayment;
}
